function SLR_OptionsList(_fee)
{
	/* Properties */
	var self = this;
	self.fee = _fee;
	self.item = {
		nb_annonces: undefined,
		// nb_supp: undefined,
		duration: undefined,
		circuit: undefined,
		use: undefined,
		use2: undefined,
		role: undefined,
		cond_percent: undefined,
		cond_negociee: undefined,
		cond_diff_percent: undefined,
		cond_diff_negociee: undefined,
		'option[post-synchro]': undefined,
		'option[saisonniere]': undefined,
		'option[panneau]': undefined,
		'option[remise]': undefined,
		'option[upgrade]': undefined,
		'option[une-station]': undefined,
		'option[combine]': undefined,
		upgrade_duration: undefined,
		upgrade_use: undefined,
		upgrade_use2: undefined,
		inm_diffusion: undefined,
		inm_duration: undefined,
		apc_tableau: undefined,
	};

	self.getOptionsList = function()
	{
		return JSON.stringify(self.item);
	};
}

$.fn.FeeCalculator = function(_e)
{
	var _fee = this;
	_fee.e = _e;
	_fee.form = _fee.find("form");
	_fee.model = new SLR_OptionsList(_fee);
	_fee.interface = {
		duration_field : _fee.find("select[name=duration]"),
		inm_duration_field : _fee.find("select[name=inm_duration]"),
		cycle_start_field : _fee.find("input[name=cycle_date1]"),
		cycle_end_field : _fee.find("input[name=cycle_date2]"),
		cycle_start_dp : undefined,
		upgrade : _fee.find(".slr-upgrade"),
		next_tab_btn : _fee.find("button[data-action='next-tab']")
	};
	_fee.baseFee = 0.00;
	_fee.upgradeFee = 0.00;
	_fee.broadcastFee = 0.00;

	_fee.calc = {
		cycle_duration: function()
		{
			var date1 = _fee.interface.cycle_start_dp.date();
			if (date1 != null){
				if (_fee.e.getConventionType() == "apc"){
					var cycleDuration = parseInt(_fee.interface.duration_field.val(), 10),
					date2 = date1.add(cycleDuration, 'days');
					_fee.interface.cycle_end_field.val(date2.format("DD-MM-YYYY")).change();
				} else if (_fee.e.getConventionType() == "inm"){
					var cycleDuration = parseInt(_fee.interface.inm_duration_field.val(), 10),
					date2 = date1.add(cycleDuration, 'days');
					_fee.interface.cycle_end_field.val(date2.format("DD-MM-YYYY")).change();
				}
			}
		},
		loaded: function()
		{
			// check boxes - only in active convention
			var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');
			activeConv.find(".input-checked input").prop("checked", true);
			_fee.calc.update_item();
		},
		update_item: function()
		{
			// loaded options to model
			_fee.model.item["nb_annonces"] = _fee.get_value("nb_annonces");
			// _fee.model.item["nb_supp"] = _fee.get_value("nb_supp");
			_fee.model.item["duration"] = _fee.get_value("duration");
			_fee.model.item["circuit"] = _fee.get_value("circuit");
			_fee.model.item["use"] = _fee.get_value("use");
			_fee.model.item["use2"] = _fee.get_value("use2");
			_fee.model.item["role"] = _fee.get_value("role");
			_fee.model.item["cond_percent"] = _fee.get_value("cond_percent");
			_fee.model.item["cond_negociee"] = _fee.get_value("cond_negociee");
			_fee.model.item["cond_diff_percent"] = _fee.get_value("cond_diff_percent");
			_fee.model.item["cond_diff_negociee"] = _fee.get_value("cond_diff_negociee");
			_fee.model.item["option[post-synchro]"] = _fee.get_value("option[post-synchro]");
			_fee.model.item["option[saisonniere]"] = _fee.get_value("option[saisonniere]");
			_fee.model.item["option[panneau]"] = _fee.get_value("option[panneau]");
			_fee.model.item["option[remise]"] = _fee.get_value("option[remise]");
			_fee.model.item["option[upgrade]"] = _fee.get_value("option[upgrade]");
			_fee.model.item["option[une-station]"] = _fee.get_value("option[une-station]");
			_fee.model.item["option[combine]"] = _fee.get_value("option[combine]");
			_fee.model.item["upgrade_use"] = _fee.get_value("upgrade_use");
			_fee.model.item["upgrade_use2"] = _fee.get_value("upgrade_use2");
			_fee.model.item["upgrade_duration"] = _fee.get_value("upgrade_duration");
			_fee.model.item["inm_diffusion"] = _fee.get_value("inm_diffusion");
			_fee.model.item["inm_duration"] = _fee.get_value("inm_duration");
			_fee.model.item["apc_tableau"] = _fee.get_value("apc_tableau");
		},
		default: function(circuit_name)
		{
			// enabled divs according to convention config
			_fee.find(".conv").hide().addClass("conv-inactive");
			_fee.find(".conv.conv-" + _fee.e.getConventionName()).css('display', '').removeClass("conv-inactive");

			var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');
			if (circuit_name == "start") {
				if (_fee.e.getConventionName() == 'apc_2024' || _fee.e.getConventionName() == 'apc_2025' || _fee.e.getConventionName() == 'apc_2026') {
					activeConv.find("input[name=tableau][value=t_a]").prop("checked", true);
					activeConv.find("input[name=circuit][value=internet]").prop("checked", true);
					activeConv.find("input[name=role][value=vhc]").prop("checked", true);
				} else {
					activeConv.find("input[name=circuit][value=radio]").prop("checked", true);
					activeConv.find("input[name=use][value=general]").prop("checked", true);
					activeConv.find("input[name=use2][value=reseau]").prop("checked", true);
					activeConv.find("input[name=role][value=vhc]").prop("checked", true);
				}
			} else if (circuit_name == "cinema"){
				activeConv.find("input[name=use][value=intermediaire]").prop("checked", true);
				activeConv.find("input[name=use2][value=eclair]").prop("checked", true);
			} else if (circuit_name == "internet"){
				activeConv.find("input[name=use][value=local]").prop("disabled", false).prop("checked", true);
			} else if (circuit_name == "publication"){
				//
			} else if (circuit_name == "ferme"){
				activeConv.find("input[name=use][value=local]").prop("checked", true);
			}

			// load initial options into model
			_fee.model.item["nb_annonces"] = _fee.get_value("nb_annonces");
			_fee.model.item["duration"] = _fee.get_value("duration");
			_fee.model.item["circuit"] = _fee.get_value("circuit");
			_fee.model.item["use"] = _fee.get_value("use");
			_fee.model.item["use2"] = _fee.get_value("use2");
			_fee.model.item["role"] = _fee.get_value("role");
			_fee.model.item["role"] = _fee.get_value("role");
			_fee.model.item["cond_percent"] = _fee.get_value("cond_percent");
			_fee.model.item["cond_negociee"] = _fee.get_value("cond_negociee");
			_fee.model.item["cond_diff_percent"] = _fee.get_value("cond_diff_percent");
			_fee.model.item["cond_diff_negociee"] = _fee.get_value("cond_diff_negociee");
			_fee.model.item["option[post-synchro]"] = _fee.get_value("option[post-synchro]");
			_fee.model.item["option[saisonniere]"] = _fee.get_value("option[saisonniere]");
			_fee.model.item["option[panneau]"] = _fee.get_value("option[panneau]");
			_fee.model.item["option[remise]"] = _fee.get_value("option[remise]");
			_fee.model.item["option[upgrade]"] = _fee.get_value("option[upgrade]");
			_fee.model.item["option[une-station]"] = _fee.get_value("option[une-station]");
			_fee.model.item["option[combine]"] = _fee.get_value("option[combine]");
			_fee.model.item["upgrade_use"] = _fee.get_value("upgrade_use");
			_fee.model.item["upgrade_use2"] = _fee.get_value("upgrade_use2");
			_fee.model.item["upgrade_duration"] = _fee.get_value("upgrade_duration");
			_fee.model.item["inm_diffusion"] = _fee.get_value("inm_diffusion");
			_fee.model.item["inm_duration"] = _fee.get_value("inm_duration");
			_fee.model.item["apc_tableau"] = _fee.get_value("apc_tableau");
		},
		enabled: function()
		{
			// enabled divs according to convention config
			_fee.find(".conv").hide().addClass("conv-inactive");
			_fee.find(".conv.conv-" + _fee.e.getConventionName()).css('display', '').removeClass("conv-inactive");
			_fee.attr('data-convention', _fee.e.getConventionName())

			// enabled field according to circuit
			var circuit = _fee.get_value('circuit');
			var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');
			activeConv.find("input[type=radio]").prop("disabled", false);
			activeConv.find("input[type=checkbox]").prop("disabled", false);

			/* INM */
			if (_fee.e.getConventionType() == "inm"){
				activeConv.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);

				/* APC 2024 */
			} else if (_fee.e.getConventionName() == 'apc_2024' || _fee.e.getConventionName() == 'apc_2025' || _fee.e.getConventionName() == 'apc_2026') {
				var tableau = _fee.get_value('apc_tableau'),
				fees = _fee.find('.conv-' + _fee.e.getConventionName()).not('.conv-inactive'),
				initial = {
					role: _fee.get_value('role'),
					circuit: _fee.get_value('circuit'),
					use: _fee.get_value('use'),
				}

				if (tableau == 'none') {
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=tv]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=internet]").prop("checked", false).prop("disabled", true);
				}
				if (tableau == 't_a' || tableau == 't_b' || tableau == 't_c' || tableau == 't_aa') {
					fees.find("input[name=circuit][value=radio]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=cinema]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=publication]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=circuit][value=ferme]").prop("checked", false).prop("disabled", true);
				}
				if (tableau == 't_a' || tableau == 't_b'|| tableau == 't_c') {
					fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
				}
				if (tableau == 't_aa') {
					fees.find("input[name=role]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", false);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", false);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", false);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", false);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
				}
				if (circuit == 'radio') {
					fees.find("input[name=use][value=general]").prop("checked", true);
					fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=ap]").prop("checked", false);
					fees.find("input[name=role][value=vhc]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=vhcap]").prop("checked", true);
					fees.find("input[name=role][value=muet]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=fp]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == 'tv') {
					fees.find("input[name='option[une-station]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=petit]").prop("checked", false).prop("disabled", true);
					if (tableau == 't_aa') {
						fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
						fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					} else if (tableau != 't_aa') {
						fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					}
					if (tableau == 't_b' || tableau == 't_c') {
						fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					}
				} else if (circuit == 'cinema' || circuit == 'publication' || circuit == 'ferme') {
					fees.find("input[name=use][value=general]").prop("checked", true);
					fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[une-station]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=petit]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-1-25]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-26-50]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant-51]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == 'internet') {
					fees.find("input[name=use][value=general]").prop("checked", true);
					fees.find("input[name=use][value=commandite]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=specialises]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[une-station]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=petit]").prop("checked", false).prop("disabled", true);
					if (tableau != 't_aa') {
						fees.find("input[name='option[combine]']").prop("checked", false).prop("disabled", true);
					}
				}
				if (circuit == 'publication') {
					fees.find("input[name=use]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role]").prop("checked", false).prop("disabled", true);
				}

				/* keep initial role if still available */
				if (fees.find('input[name="role"][value="' + initial.role + '"]').prop('disabled') === false) {
					fees.find('input[name="role"][value="' + initial.role + '"]').prop('checked', true)
				}
				if (fees.find('input[name="use"][value="' + initial.use + '"]').prop('disabled') === false) {
					fees.find('input[name="use"][value="' + initial.use + '"]').prop('checked', true)
				}
				if (fees.find('input[name="circuit"][value="' + initial.circuit + '"]').prop('disabled') === false) {
					fees.find('input[name="circuit"][value="' + initial.circuit + '"]').prop('checked', true)
				}

				/* par défaut si rien sélectionné */
				if (tableau == 'none') {
					if (_fee.get_value('circuit') == undefined) {
						fees.find('input[name="circuit"][value="radio"]').prop('checked', true).trigger('change')
						fees.find('input[name="use"][value="general"]').prop('checked', true).trigger('change')
					}
					if (_fee.get_value('role') == undefined) {
						fees.find('input[name="role"][value="ap"]').prop('checked', true).trigger('change')
					}
				}

				/* APC 2021-2024 */
			} else {
				var fees = _fee.find('.conv-' + _fee.e.getConventionName()).not('.conv-inactive')
				if (circuit == "radio"){
					fees.find("input[name=use][value=intermediaire]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=muet]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=fp]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=figurant]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=demonstrateur]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "tv"){
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
				} else if (circuit == "cinema"){
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=general]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=local]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "internet"){
					fees.find("input[name=use][value=general]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=intermediaire]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "publication"){
					fees.find("input[name=use]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[post-synchro]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[saisonniere]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[panneau]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[remise]']").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				} else if (circuit == "ferme"){
					fees.find("input[name=use][value=general]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use][value=intermediaire]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-eclair]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=use2][value=comm-reseau]").prop("checked", false).prop("disabled", true);
					fees.find("input[name=role][value=doublage]").prop("checked", false).prop("disabled", true);
					fees.find("input[name='option[upgrade]']").prop("checked", false).prop("disabled", true);
				}
			}

			// number label
			if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[panneau]']").prop('checked') == true){
				_fee.find("label[for=nb_annonces]").text("panneau(x)");
			} else if (circuit == "publication"){
				_fee.find("label[for=nb_annonces]").text("publication(s)");
			} else {
				_fee.find("label[for=nb_annonces]").text("annonce(s)");
			}

			// Récupération des références sur les deux selects et de la valeur actuellement sélectionnée
			var durationSelect = _fee.find('select[name=duration]'),
			upgradeDurationSelect = _fee.find('select[name=upgrade_duration]');
			var currentValue = _fee.interface.duration_field.val();

			// Sauvegarder les options originales pour chacun (si ce n'est pas déjà fait)
			if (!durationSelect.data('originalOptions')) {
				durationSelect.data('originalOptions', durationSelect.html());
			}
			if (!upgradeDurationSelect.data('originalOptions')) {
				upgradeDurationSelect.data('originalOptions', upgradeDurationSelect.html());
			}

			// Traitement spécifique pour la convention apc_2024, apc_2025, apc_2026
			let select90 = false
			if (_fee.getConventionName() === 'apc_2024' || _fee.getConventionName() === 'apc_2025' || _fee.getConventionName() === 'apc_2026') {
				if (tableau === "none") {
					durationSelect.html(durationSelect.data('originalOptions'));
					_fee.interface.duration_field.selectpicker('refresh');
					// Select 90 days by default (same as tableau A)
					if (currentValue !== "90") {
						select90 = true;
						_fee.interface.duration_field.selectpicker('val', "90");
					}
				} else if (tableau === "t_aa" || tableau === "t_c") {
					if (durationSelect.find('option[value="365"]').length === 0) {
						durationSelect.append('<option value="365">1 an</option>');
					}
					durationSelect.find('option').each(function(){
						if ($(this).val() !== "365") {
							$(this).remove();
						}
					});
					_fee.interface.duration_field.selectpicker('refresh');
					if (currentValue !== "365") {
						_fee.interface.duration_field.selectpicker('val', "365");
					}
				} else if (tableau === "t_a" || tableau === "t_b") {
					var allowed = ["7", "14", "21", "90"];
					durationSelect.find('option').each(function(){
						if ($.inArray($(this).val(), allowed) === -1) {
							$(this).remove();
						}
					});
					var labels = {
						"7": "7 jours",
						"14": "14 jours",
						"21": "21 jours",
						"90": "90 jours"
					};
					allowed.forEach(function(val) {
						if (durationSelect.find('option[value="'+val+'"]').length === 0) {
							durationSelect.append('<option value="'+val+'">'+labels[val]+'</option>');
						}
					});
					_fee.interface.duration_field.selectpicker('refresh');
					if ($.inArray(currentValue, allowed) === -1) {
						select90 = true
						_fee.interface.duration_field.selectpicker('val', "90");
					}
				}
			} else {
				var hasOneYearOption = (durationSelect.find('option[value="365"]').length > 0);
				var shouldHaveOneYearOption = ((_fee.getConventionName() === 'apc_2024' || _fee.getConventionName() === 'apc_2025' || _fee.getConventionName() === 'apc_2026') || circuit === 'internet');
				if (hasOneYearOption && !shouldHaveOneYearOption)  {
					var wasOneYear = (currentValue === "365");
					durationSelect.find('option[value="365"]').remove();
					_fee.interface.duration_field.selectpicker('refresh');
					if (wasOneYear) {
						_fee.interface.duration_field.selectpicker('val', "90");
					}
				} else if (!hasOneYearOption && shouldHaveOneYearOption) {
					durationSelect.append('<option value="365">1 an</option>');
					_fee.interface.duration_field.selectpicker('refresh');
				}
			}

			upgradeDurationSelect.html(durationSelect.html());
			upgradeDurationSelect.selectpicker('refresh');
			if (select90) { requestAnimationFrame(function() {
				upgradeDurationSelect.selectpicker('val', "90");
			}) }


			// upgrade interface
			if (_fee.find(".conv.conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[upgrade]']").prop('checked') == true && _fee.e.getConventionType() == "apc"){
				_fee.interface.upgrade.fadeIn("fast");
			} else {
				_fee.interface.upgrade.fadeOut("fast");
			}
		},
		option: function(path)
		{
			var value = 0;
			if (path.length == 1){
				value = asFloat(_fee.e.getConventionData().options[path[0]]);
			} else if (path.length == 2){
				value = asFloat(_fee.e.getConventionData().options[path[0]][path[1]]);
			}
			if (isNaN(value)){
				value = 0;
			}
			return value;
		},
		base_fee: function()
		{
			// calculate base fee
			var	base_fee = _fee.calc.dig(_fee.e.getConventionData(), 'base'),
			mod_fee = _fee.calc.mod(base_fee, 'base');

			// fee can't be under zero
			if (mod_fee < 0){
				mod_fee = 0;
			}
			return mod_fee;
		},
		upgrade_fee: function()
		{
			// calculate upgrade fee
			var upgrade_fee = _fee.calc.dig(_fee.e.getConventionData(), 'upgrade'),
			mod_fee = _fee.calc.mod(upgrade_fee, 'upgrade'),
			displayed_fee = mod_fee - _fee.baseFee;

			// upgrade can't be under zero
			if (displayed_fee < 0){
				displayed_fee = 0;
			}
			return displayed_fee;
		},
		broadcast_fee: function()
		{
			// calculate broadcast fee
			var broadcast_fee = _fee.calc.dig(_fee.e.getConventionData(), 'broadcast'),
			mod_fee = _fee.calc.mod(broadcast_fee, 'broadcast');

			// broadcast can't be under zero
			if (mod_fee < 0){
				mod_fee = 0;
			}
			return mod_fee;
		},
		dig: function(tree, parameters)
		{
			for (var key in tree) {
				if (key === "options" || key === "types"){
					continue;
				}
				var command = key.split(":");
				switch (command[0]) {
					case 'use':
					case 'use2':
						if (parameters === "upgrade" && _fee.get_value("upgrade_"+command[0]) == command[1]){
							return _fee.calc.dig(tree[key], parameters);
						} else if (parameters === "base" && _fee.get_value(command[0]) == command[1]){
							return _fee.calc.dig(tree[key], parameters);
						}
						break;
					case 'circuit':
					case 'role':
					case 'inm_diffusion':
					case 'inm_duration':
					case 'apc_tableau':
					if (_fee.get_value(command[0]) == command[1]){
						return _fee.calc.dig(tree[key], parameters);
					}
					break;
					case 'if':
					var value = asFloat(_fee.get_value(command[1])),
					operator = command[2],
					operationNumber = asFloat(command[3]);
					switch (operator){
						case '==':
						case '=':
						if (value == operationNumber){
							return _fee.calc.dig(tree[key], parameters);
						}
						break;
						case '>=':
						if (value >= operationNumber){
							return _fee.calc.dig(tree[key], parameters);
						}
						break;
					}
					break;
					case 'fee':
					if (parameters == 'base' || parameters == 'upgrade'){
						return asFloat(tree[key]);
					}
					break;
					case 'broadcast':
					if (parameters == "broadcast"){
						return _fee.calc.dig(tree[key], parameters);
					}
					case 'broadcast_fee':
					if (parameters == 'broadcast' || parameters == 'upgrade'){
						return asFloat(tree[key]);
					}
					default:
					return -1;
				}
			}
			return -1;
		},
		mod: function(fee, parameters)
		{
			// cond_negociee négociée
			if (parameters == "broadcast"){
				var cond_negociee = asFloat(_fee.get_value('cond_diff_negociee'));
				if (cond_negociee){
					return cond_negociee;
				}
			} else {
				var cond_negociee = asFloat(_fee.get_value('cond_negociee'));
				if (cond_negociee){
					return cond_negociee;
				}
			}

			// number of ads
			var numberOfAds = parseInt(_fee.get_value('nb_annonces'), 10);
			if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[panneau]']").prop('checked') == true){
				fee *= _fee.calc.option(["numberofads", numberOfAds]);
			} else {
				if (numberOfAds){
					fee *= numberOfAds;
				} else {
					return 0;
				}
			}

			// condition pourcentage
			if (parameters == "broadcast"){
				var percentage = asFloat(_fee.get_value('cond_diff_percent'))/100;
				fee *= percentage;
			} else {
				var percentage = asFloat(_fee.get_value('cond_percent'))/100;
				fee *= percentage;
			}

			// tv / radio seulement
			if (_fee.e.getConventionType() === "apc")
			{
				// post-synchro: 125%
				if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[post-synchro]']").prop('checked') == true){
					fee *= _fee.calc.option(["post-synchro"]);
				}

				// remise en onde: 150%
				if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[remise]']").prop('checked') == true){
					fee *= _fee.calc.option(["remise"]);
				}

				// durée de cycle
				if (parameters == 'base' && _fee.get_value('duration') != undefined){
					fee *= _fee.calc.option(["duration", _fee.get_value('duration').toString()]);
				} else if (parameters == "upgrade" && _fee.get_value('upgrade_duration') != undefined){
					fee *= _fee.calc.option(["duration", _fee.get_value('upgrade_duration').toString()]);
				}
			}

			// final base fee
			return fee;
		},
		role_fee: function(item_type)
		{
			var data = _fee.e.getConventionData();
			if (_fee.get_value('role') && item_type){
				return data['role:' + _fee.get_value('role')].items[item_type];
			}
			return 0;
		}
	};

	_fee.import = function(config_name, options_list)
	{
		// set config name
		_fee.e.find("select[name=config]").val(config_name);
		_fee.e.find("select[name=config]").change();

		// set circuit BEFORE applying default/enabled to avoid it being reset
		var tempConv = _fee.find(".conv-" + _fee.e.getConventionName());
		tempConv.find(":input[name=circuit][value=" + options_list.circuit + "]").prop("checked", true);

		// Apply default and enabled which will set .conv-inactive classes
		_fee.calc.default(options_list.circuit);
		_fee.calc.enabled();

		// NOW define activeConv after classes are set
		var activeConv = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive');

		// set upgrade
		if (options_list['option[upgrade]'] && options_list['option[upgrade]'] == 'on'){
			activeConv.find(":input[name='option[upgrade]']").prop("checked", true);
		} else {
			activeConv.find(":input[name='option[upgrade]']").prop("checked", false);
		}

		//  set options
		for (var key in options_list){
			switch (key) {
				case 'nb_annonces':
				// case 'nb_supp':
				case 'cond_negociee':
				case 'cond_percent':
				case 'cond_diff_negociee':
				case 'cond_diff_percent':
				activeConv.find(":input[name=" + key + "]").val(options_list[key]);
				break;
				case 'duration':
				case 'upgrade_duration':
				case 'inm_duration':
				case 'upgrade_use':
				case 'upgrade_use2':
				activeConv.find(":input[name=" + key + "]").val(options_list[key]);
				activeConv.find(":input[name=" + key + "]").selectpicker('refresh');
				break;
				case 'use':
				case 'use2':
				case 'role':
				case 'inm_diffusion':
				case 'apc_diffusion':
				activeConv.find(":input[name=" + key + "][value=" + options_list[key] + "]").prop("checked", true);
				break;
				case 'option[saisonniere]':
				case 'option[post-synchro]':
				case 'option[remise]':
				case 'option[panneau]':
				case 'option[une-station]':
				case 'option[combine]':
				activeConv.find(":input[name='" + key + "']").prop("checked", true);
				break;
			}
		}

		// uncheck if not checked
		if (!options_list['option[saisonniere]']){
			activeConv.find(":input[name='option[saisonniere]']").prop("checked", false);
		}
		if (!options_list['option[panneau]']){
			activeConv.find(":input[name='option[panneau]']").prop("checked", false);
		}
		if (!options_list['option[remise]']){
			activeConv.find(":input[name='option[remise]']").prop("checked", false);
		}
		if (!options_list['option[post-synchro]']){
			activeConv.find("input[name='option[post-synchro]']").prop("checked", false);
		}
		if (!options_list['option[une-station]']){
			activeConv.find(":input[name='option[une-station]']").prop("checked", false);
		}
		if (!options_list['option[combine]']){
			activeConv.find("input[name='option[combine]']").prop("checked", false);
		}

		// save
		_fee.calc.update_item();
		_fee.changed({target:_fee});
	};

	_fee.changed = function(event)
	{
		// variables
		var field = $(event.target),
		key = undefined,
		value = undefined;

		// datetime picker
		if (field.data("DateTimePicker") != undefined){
			key = field.find("input").attr("name");
			var date = field.data("DateTimePicker").date();
			value = (date != null) ? field.data("DateTimePicker").date().format("YYYY-MM-DD 00:00:00") : '';

			// checkboxes
		} else if (field.attr("type") == "checkbox"){
			key = field.attr("name");
			value = field.prop("checked") ? "on" : undefined;

			// normal fields
		} else {
			key = field.attr("name");
			value = field.val();
		}

		// floats
		if (key == "cond_negociee" || key == "cond_diff_negociee"){
			value = asFloat(value);
			if (isNaN(value)){
				value = "0,00";
			} else {
				value = value.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			}
			field.val(value);
		}

		// ints
		if (key == "cond_percent" || key == "cond_diff_percent"){
			value = parseInt(value, 10);
			if (isNaN(value) || value <= 0){
				value = 100;
			}
			field.val(value);
		}

		// actions
		if (key == 'apc_tableau' || key == "circuit" || key == "option[panneau]" || key == "option[upgrade]" || key == "config"){
			_fee.calc.default(field.val());
			_fee.calc.enabled();
		} else if (key == "cycle_date1"){
			_fee.calc.cycle_duration();
		} else if (key == "duration" || key == "inm_duration"){
			_fee.calc.cycle_duration();
		}

		// automatically update fee
		_fee.updateFee();

		// element set
		if (key == "cycle" || key == "cycle_date1" || key == "cycle_date2"){
			_fee.e.set(key, value);
		} else {
			_fee.calc.update_item();
			_fee.e.updateOptionsList();
		}
	};

	_fee.get_value = function(key)
	{
		// input fields - exclude inactive conventions
		var input = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='" + key + "']"),
		select = undefined;
		if (!input.length){
			select = _fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("select[name='" + key + "']");
			if (!input.length && !select.length){
				return undefined;
			}
		}
		if (key === "cycle_date1" || key === "cycle_date2"){
			if (input.closest('.element-date-picker').length){
				var date = input.closest('.element-date-picker').data("DateTimePicker").date();
				return (date != null) ? date.format("YYYY-MM-DD 00:00:00") : '';
			} else {
				return '';
			}
		} else if (input.length){
			if (input.attr("type") == "checkbox" || input.attr("type") == "radio"){
				return input.filter(':checked').val();
			} else {
				return input.val();
			}
		} else if (select.length){
			return select.val();
		}
	};

	_fee.updateFee = function()
	{
		_fee.baseFee = _fee.calc.base_fee();
		_fee.upgradeFee = (_fee.e.getConventionType() == "apc") ? _fee.calc.upgrade_fee() : 0;
		_fee.broadcastFee = (_fee.e.getConventionType() == "inm") ? _fee.calc.broadcast_fee() : 0;
		_fee.e.updateInterface();
	};

	_fee.getFee = function()
	{
		return _fee.baseFee;
	};

	_fee.getUpgrade = function()
	{
		if (_fee.find(".conv-" + _fee.e.getConventionName()).not('.conv-inactive').find("input[name='option[upgrade]']").prop('checked') == true){
			return _fee.upgradeFee;
		}
		return 0;
	};

	_fee.getBroadcast = function()
	{
		if (_fee.e.getConventionType() == "inm"){
			return _fee.broadcastFee;
		}
		return 0;
	};

	_fee.getConventionName = function()
	{
		return _fee.e.find("select[name=config]").val();
	};

	_fee.getOptionsList = function()
	{
		return _fee.model.getOptionsList();
	};

	return function()
	{
		// dynamic interface elements
		_fee.interface.cycle_start_dp = _fee.interface.cycle_start_field.closest('.element-date-picker').data("DateTimePicker");

		// checked options
		if (_fee.form.data("loaded") == true){
			_fee.calc.loaded();
			_fee.calc.enabled();
			_fee.updateFee();
		} else {
			_fee.calc.default("start");
			_fee.calc.enabled();
			_fee.updateFee();
		}
		_fee.e.setInitialOptionsList();

		// calculator elements changed
		_fee.on("change", _fee.changed);
		_fee.find('.element-date-picker').each(function(){
			$(this).on('dp.change', _fee.changed);
		});
		_fee.e.find("select[name=config]").on("change", function(){
			_fee.e.set("config", $(this).val());
			_fee.changed({target:$(this)});
		});

		// selectpicker
		_fee.find("select").each(function(){
			if ($(this).hasClass("select")){
				$(this).selectpicker({
					size: 5
				});
			}
		});

		// next tab button
		_fee.interface.next_tab_btn.on("click", function(){
			_fee.e.reachTab(2);
			return false;
		});

		// return object
		return _fee;
	}();
};
